import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "row py-3 bt-dash" }
const _hoisted_2 = {
  class: "custom-scrollbar list-container px-3 nav-link",
  style: {"height":"50dvh"}
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src"]

import { ref, reactive, onMounted, computed, watch } from 'vue'
import { LinkGroups } from '@/store/management/productsStore'
import { useProductsStore } from '@/store/management/productsStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'productLinkGroups',
  setup(__props) {

const productStore = useProductsStore()

const compState = reactive({
    selectedProductGroup: [] as LinkGroups[],
})

const productGroupMock: LinkGroups[] = [
    { id: '1', name: 'Appetizers', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium', displayMode: 'default' } },
    { id: '2', name: 'Salads', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium', displayMode: 'default' } },
    { id: '3', name: 'Soups', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium', displayMode: 'default' } },
    { id: '4', name: 'Main Courses', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium', displayMode: 'default' } },
    { id: '5', name: 'Sides', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium', displayMode: 'default' } },
    { id: '6', name: 'Desserts', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium', displayMode: 'default' } },
    { id: '7', name: 'Beverages', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium', displayMode: 'default' } },
    { id: '8', name: 'Cocktails', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium', displayMode: 'default' } },
    { id: '9', name: 'Wine', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium', displayMode: 'default' } },
    { id: '10', name: 'Beer', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium', displayMode: 'default' } },
    { id: '11', name: 'Breakfast', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium', displayMode: 'default' } },
    { id: '12', name: 'Lunch', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium', displayMode: 'default' } },
    { id: '13', name: 'Dinner', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium', displayMode: 'default' } },
    { id: '14', name: 'Specials', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium', displayMode: 'default' } },
    { id: '15', name: 'Kids Menu', appearance: { image: '', buttonColor: '7', fontSizes: 'Medium', displayMode: 'default' } },
];

const colorList = ref([
    { id: '1', name: 'Red', color: '#FF0000' },
    { id: '2', name: 'Green', color: '#00aa00' },
    { id: '3', name: 'Blue', color: '#0000FF' },
    { id: '4', name: 'Yellow', color: '#FFFF00' },
    { id: '5', name: 'Cyan', color: '#00FFFF' },
    { id: '6', name: 'Magenta', color: '#FF00FF' },
    { id: '7', name: 'Orange', color: '#FFA500' },
    { id: '8', name: 'Purple', color: '#800080' },
    { id: '9', name: 'Brown', color: '#A52A2A' },
    { id: '10', name: 'Pink', color: '#FFC0CB' },
    { id: '11', name: 'Lime', color: '#32cd32' },
    { id: '12', name: 'Teal', color: '#008080' },
]);


const activeProduct = computed(() => {
    return productStore.getActiveProduct
})

const tempActiveProduct = computed(() => {
    return productStore.getTempActiveProduct
})

const activeProductId = computed(() => {
    return productStore.getActiveProductId
})

onMounted(() => {
    if (tempActiveProduct.value?.basic.productNumber) {
        compState.selectedProductGroup = tempActiveProduct.value?.linkGroups || [] as LinkGroups[]
    }
})

watch(activeProductId, (newVal) => {
    if (tempActiveProduct.value?.basic.productNumber) {
        compState.selectedProductGroup = activeProduct.value?.linkGroups || [] as LinkGroups[]
    }
}, { immediate: true });

watch(compState, (newVal) => {
    productStore.setTempActiveProduct({
        ...tempActiveProduct.value,
        linkGroups: newVal.selectedProductGroup
    })
}, { deep: true });

const findOnSelectedProductGroup = (id: string) => {
    return compState.selectedProductGroup.find((productGroup) => productGroup.id === id)
}

const findColorById = (id: string) => {
    return colorList.value.find((color) => color.id === id)?.color || '#dddddd'
}

const calcFontSize = (fontSize: string) => {
    return fontSize === 'X-Large' ? '1.5rem' : fontSize === 'Large' ? '1.25rem' : fontSize === 'Medium' ? '1rem' : '0.875rem'
}

const onProductGroupClick = (id: string) => {
    const productGroup = productGroupMock.find((productGroup) => productGroup.id === id)
    if (findOnSelectedProductGroup(id)) {
        compState.selectedProductGroup = compState.selectedProductGroup.filter((productGroup) => productGroup.id !== id)
    } else {
        if (productGroup) {
            compState.selectedProductGroup.push(productGroup)
        }

    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h6", { class: "f-w-700 my-3" }, "Product Group", -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(productGroupMock, (item) => {
        return _createElementVNode("div", {
          class: "text-center text-white rounded-3 hover-pointer card mb-0 d-flex flex-column justify-content-center align-items-center gap-2",
          onClick: ($event: any) => (onProductGroupClick(item.id)),
          style: _normalizeStyle([{ backgroundColor: findColorById(item.appearance.buttonColor), boxShadow: findOnSelectedProductGroup(item.id) ? 'inset 0 0 16px rgba(0, 0, 0, 0.7)' : 'none' }, {"grid-column":"span 1 / span 1","height":"112px"}])
        }, [
          (item?.appearance?.image)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: item.appearance.image,
                alt: "department image",
                class: "object-fit-cover w-25 ratio1-1 border-0"
              }, null, 8, _hoisted_4))
            : _createCommentVNode("", true),
          _createElementVNode("h5", {
            class: "text-white",
            style: _normalizeStyle({ fontSize: calcFontSize(item.appearance.fontSizes) })
          }, _toDisplayString(item.name), 5)
        ], 12, _hoisted_3)
      }), 64))
    ])
  ]))
}
}

})